"use strict";
/*
 * Created on 25. 2. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var WindowPromoEffectBase_1 = require("./WindowPromoEffectBase");

var WindowPromoEffectSiteBase =
/*#__PURE__*/
function (_WindowPromoEffectBas) {
  _inherits(WindowPromoEffectSiteBase, _WindowPromoEffectBas);

  function WindowPromoEffectSiteBase(id, windowId, promotionId, products, userTotalAmounts, positiveIncrementAmounts, postPromoAmounts, postPromoDates, baselineProducts, baselineAmounts, cannibalization, dailyTotals, //daily split of total amount for product with increment
  historic, siteId) {
    var _this;

    _classCallCheck(this, WindowPromoEffectSiteBase);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowPromoEffectSiteBase).call(this, id, windowId, promotionId, products, userTotalAmounts, positiveIncrementAmounts, postPromoAmounts, postPromoDates, baselineProducts, baselineAmounts, cannibalization, dailyTotals, historic));
    _this.siteId = siteId;
    return _this;
  }

  return WindowPromoEffectSiteBase;
}(WindowPromoEffectBase_1.WindowPromoEffectBase);

exports.WindowPromoEffectSiteBase = WindowPromoEffectSiteBase;

WindowPromoEffectSiteBase.schema = function () {
  var bld = new StructPropBuilder_1.StructPropBuilder(WindowPromoEffectSiteBase.name);
  return Object.assign({
    siteId: bld.id('siteId')
  }, WindowPromoEffectBase_1.WindowPromoEffectBase.schema);
}();